import { memo } from "react";

import { INiche } from "@/common/services/types";

import { NichePreviewAvatar } from "@/components/niches/NichePreviewAvatar";
import { NichePreviewInfo } from "@/components/niches/NichePreviewInfo";
import { NichePreviewButton } from "@/components/niches/NichePreviewButton";
import { NichePreviewImages } from "@/components/niches/NichePreviewImages";

import "./NichePreview.scss";

interface INichePreviewProps {
  niche: INiche;
  following: boolean;
  isLink?: boolean;
  withPreview?: boolean;
  onPreviewClick?: () => void;
  onFollow: (id: string, status: boolean) => void;
}

export const NichePreview = memo(({
  niche,
  following,
  withPreview,
  isLink,
  onFollow,
  onPreviewClick
}: INichePreviewProps) => {
  return (
    <div className="NichePreview">
      <div className="NichePreview-Header">
        <NichePreviewAvatar niche={niche} onPreviewClick={onPreviewClick} />
        <NichePreviewInfo niche={niche} onPreviewClick={onPreviewClick} />
        <NichePreviewButton
          niche={niche}
          following={following}
          isLink={isLink}
          onFollow={onFollow}
          onPreviewClick={onPreviewClick} />
      </div>

      <NichePreviewImages niche={niche} withPreview={withPreview} onPreviewClick={onPreviewClick} />
    </div>
  );
});
